import * as React from 'react';
import { UIHeading1, UIHeading2, UIText1, useDeviceType } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IWhyNeedSdelkaItemProps {
  icon: string;
  title: string;
  description: string;
}

export const WhyNeedSdelkaItem: React.FC<IWhyNeedSdelkaItemProps> = ({ icon, title, description }) => {
  const device = useDeviceType();
  const isDesktop = device === 'desktop';
  const Title = isDesktop ? UIHeading1 : UIHeading2;

  return (
    <div className={styles['item']}>
      <div className={styles['img']}>
        <img src={icon} />
      </div>

      <div>
        <Title color="text-primary-default">{title}</Title>
        <UIText1 color="text-secondary-default">{description}</UIText1>
      </div>
    </div>
  );
};
